import React from "react";
import { GameState } from "../../../core/protocol/types";
import ScoreboardOverlaySurvivor from "./ScoreboardOverlaySurvivor";
import ScoreboardOverlayFFA from "./ScoreboardOverlayFFA";

interface ScoreboardOverlayProps {
  gameState: GameState | null;
  localStats: { score: number; level: number; lines: number };
}

const ScoreboardOverlay: React.FC<ScoreboardOverlayProps> = ({
  gameState,
  localStats,
}) => {
  // Allow scoreboard to show during "active" and "starting" statuses
  // TAB should work whenever not in lobby ("waiting") or results ("finished")
  if (!gameState || !gameState.players || (gameState.status !== "active" && gameState.status !== "starting")) {
    return null;
  }

  // Render the appropriate scoreboard based on game mode
  if (gameState.gameMode === "survivor") {
    return <ScoreboardOverlaySurvivor gameState={gameState} localStats={localStats} />;
  }

  return <ScoreboardOverlayFFA gameState={gameState} localStats={localStats} />;
};

export default ScoreboardOverlay;
